var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-wizard-panel-footer" },
    [
      !_vm.hasFormSteps
        ? _c("CompassButton", {
            attrs: {
              label: _vm.translations.activateAutomation,
              leftIcon: "check",
              loading: _vm.isLoading
            },
            on: {
              click: function($event) {
                return _vm.$emit("activate-automation")
              }
            }
          })
        : [
            !_vm.isFirstStep
              ? _c("CompassButton", {
                  attrs: {
                    label: _vm.translations.previous,
                    type: "tertiary",
                    leftIcon: "arrow-left",
                    disabled: _vm.isLoading
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("previous-step")
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: {
                label: _vm.nextButtonLabel,
                leftIcon: _vm.isLastStep ? "check" : "",
                loading: _vm.isLoading
              },
              on: {
                click: function($event) {
                  return _vm.$emit("next-step")
                }
              }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }